import React, { useState } from 'react'
import { SideMenu } from '../'
import Header from '../Header/Header'
import { useSelector } from 'react-redux'
import { Redirect } from 'react-router-dom'
import paths from '../../Config/paths'

const MenuLayout = ({ component: Component, setLanguage, language, ...props }) => {
    const user = useSelector(state => state.authReducer.user)
    const [visible, setVisible] = useState(false)
    if (!user) {
        return (
            <Redirect to={paths?.LOGIN} />
        )
    }
    return (
        <div className='helper-main'>
            <Header setVisible={setVisible} visible={visible} />
            <div className='menu-flex'>
                <div className={'sidebarSection'}>
                    <SideMenu language={language} visible={visible} setVisible={setVisible} />
                </div>
                <div className={'helper-comp'}>
                    <Component setLanguage={setLanguage} language={language} {...props} />
                </div>
            </div>
        </div>
    )
}

export { MenuLayout }